var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parent",staticStyle:{"width":"100%"}},[_c('canvas',{ref:"body",attrs:{"id":"video"}})])}
var staticRenderFns = []

export { render, staticRenderFns }